import { Typography } from "@mui/material";
import "./styles.css";
import Latex from "react-latex-next";

export default function Controls({ controls }) {
  const { dt, setDt } = controls;
  return (
    <div className="controls">
      <div className="controlGroup">
        <Typography variant="h5" style={{ paddingBottom: 20 }}>
          Numerical Methods for <br />
          Ordinary Differential Equations (ODE)
        </Typography>
        <Typography style={{ paddingBottom: 20, textAlign: "left" }}>
          Here, we try to visualize how Euler Method, 2nd Runge-Kutta(Modified
          Euler Method) and 4th Runge-Kutte(RK4) work.
        </Typography>
        <Typography style={{ paddingBottom: 20, textAlign: "left" }}>
          This is the critical parameter in Numerical Methods. Feel free to
          change it and see the result.
        </Typography>
        <div className="control">
          <Latex>$\Delta t$</Latex>
          <input
            style={{ marginLeft: 10 }}
            value={dt}
            onChange={(e) => {
              if (parseFloat(e.target.value) > 0)
                setDt(parseFloat(e.target.value));
            }}
            step={0.01}
            type="number"
          />
        </div>
        <Typography
          style={{ paddingTop: 20, paddingBottom: 20, textAlign: "left" }}
        >
          Here, we try to solve a ODE which is:
          <Latex>{`$$y^{'} = sin(t)^2 \\cdot y$$`}</Latex>
          This is the example of{" "}
          <a href="https://en.wikipedia.org/wiki/Runge%E2%80%93Kutta_methods">
            RK4 wiki
          </a>
          . I implemented it to let you can see how <Latex>$\Delta t$</Latex>{" "}
          influence the results.
        </Typography>
        <Typography variant="h6">Euler Method</Typography>
        <Typography style={{ paddingBottom: 20, textAlign: "left" }}>
          <Latex>{`$$y \\leftarrow y + \\Delta t \\cdot y^{'}$$`}</Latex>
          Basically, the Euler Method only consider the first order term in
          Taylor Series, so the second, thrid and more terms become its error.
          To reduce the error, you have to use really small{" "}
          <Latex>$\Delta t$</Latex>, but it will cause lots of computation time.
          You can try to reduce the <Latex>$\Delta t$</Latex> and see the result
          on the right side.
        </Typography>
        <Typography variant="h6">
          2nd Runge-Kutte (Modified Euler Method)
        </Typography>
        <Typography style={{ paddingBottom: 20, textAlign: "left" }}>
          <Latex>{`$$y_m \\leftarrow y + \\frac{\\Delta t}{2} \\cdot y^{'}
            \\\\ k1 = y^{'}(y_m, t_0+\\frac{\\Delta t}{2})
            \\\\ y \\leftarrow y + \\Delta t \\cdot k1$$`}</Latex>
          2nd Runge-Kutte consider the first and second order term in Taylor
          Series. The error is less than the Euler Method.
        </Typography>
        <Typography variant="h6">4th Runge-Kutte (RK4)</Typography>
        <Typography style={{ paddingBottom: 20, textAlign: "left" }}>
          <Latex>{`$$ k_1 = y^{'}(y^*(t_0), t_0)$$`}</Latex>
          <Latex>{`$$ k_2 = y^{'}(y^*(t_0)+k_1\\frac{\\Delta t}{2}, t_0 + \\frac{\\Delta t}{2})$$`}</Latex>
          <Latex>{`$$ k_3 = y^{'}(y^*(t_0)+k_2\\frac{\\Delta t}{2}, t_0 + \\frac{\\Delta t}{2})$$`}</Latex>
          <Latex>{`$$k_4 = y^{'}(y^*(t_0)+k_3\\frac{\\Delta t}{2}, t_0 + \\Delta t)$$`}</Latex>
          <Latex>{`$$y \\leftarrow y + \\Delta t \\cdot \\frac{k_1+2k_2+2k_3+k_4}{6}$$`}</Latex>
          4th Runge-Kutte consider the first to fourth order terms in Taylor
          Series. The error is less than the above two methods. It is the most
          popular method in Numerial Methods for ODE.
        </Typography>
      </div>
    </div>
  );
}
